<template>
  <a-card title='魔方云直连' style="margin: auto;width: 80%;background-color: white" :bordered="false">
    <a-tabs v-model="activeKey">
      <a-tab-pane tab="店铺授权码" :key="0">
        <AuthorizationCode :details="details" @unBindSuccess="unBindSuccessEvent"></AuthorizationCode>
      </a-tab-pane>
      <a-tab-pane tab="商品同步记录" :key="2">
        <ProductSynchronousRecording v-if="details.authId" :auth-id="details.authId"></ProductSynchronousRecording>
      </a-tab-pane>
      <!--        <a-tab-pane tab="订单直连记录" :key="1">-->
      <!--          <OrderSynchronousRecording ></OrderSynchronousRecording>-->
      <!--        </a-tab-pane>-->
    </a-tabs>
  </a-card>
</template>

<script>
import AuthorizationCode from '@/views/service/serviceProvider/moFangCloud/components/AuthorizationCode'
// import OrderSynchronousRecording from '@/views/service/serviceProvider/moFangCloud/components/OrderSynchronousRecording'
import ProductSynchronousRecording
  from '@/views/service/serviceProvider/moFangCloud/components/ProductSynchronousRecording'
import Vue from 'vue'

export default {
  name: 'MoFangCloud',
  components: { AuthorizationCode, ProductSynchronousRecording },
  data() {
    return {
      code: '',
      activeKey: 0,
      details: {}
    }
  },
  mounted() {
    this.code = this.getPageParams().code
    this.getDetails(this.code)
  },
  methods: {
    getDetails(code) {
      let details = Vue.ls.get(code)
      if (details) {
        this.details = details
        this.$store.commit('SET_AUTHORIZED_USER_NAME', details.taoBaoUserNick ? details.taoBaoUserNick : '--')
      } else {
        const params = { code: code }
        this.getHttpServices().getServerApiService().get('feizhu/taobao/taoBaoLinkServiceNotify', params)
          .then(details => {
            this.details = details
            if (details.authId) {
              this.$store.commit('SET_AUTHORIZED_USER_NAME', details.taoBaoUserNick ? details.taoBaoUserNick : '--')
              Vue.ls.set(code, details, 6 * 60 * 60 * 1000)
            } else {
              //跳转去授权
              this.toAuthorization()
            }
          }).catch(reason => {
          this.showNetWorkErrorMessage(reason)
        })
      }
    },
    toAuthorization() {
      this.getHttpServices().getServerApiService().post('feizhu/taobao/taoBaoAuth')
        .then(url => {
          location.href = url
        }).catch(reason => {
        this.showNetWorkErrorMessage(reason)
      })
    },
    unBindSuccessEvent(authCode) {
      this.details = {
        ...this.details,
        authCode: authCode
      }
      Vue.ls.set(this.code, this.details, 6 * 60 * 60 * 1000)
    }
  }

}
</script>
<style scoped>
</style>